// extracted by mini-css-extract-plugin
module.exports = {"videoPlayerWrap":"video-player-warp_videoPlayerWrap__IZA_u","videoPlayer":"video-player-warp_videoPlayer__2drSn"};